import React from 'react';
import './ViewOnlyBadge.scss';

const ViewOnlyBadge = () => {
  return <div className="ViewOnlyBadge">View-only</div>;
};
export default ViewOnlyBadge;
